<template>
  <v-footer height="auto" color="secondary" class="pa-2 white--text text-xs-center">
    <v-layout row wrap justify-center>
      <v-flex class="pb-1 body-1" xs12 md8>
        <v-btn to="/terms" :disabled="appLoading" small flat dark>Terms</v-btn>
        <v-btn to="/privacy" :disabled="appLoading" small flat dark>Privacy</v-btn>
        <v-btn to="/contact" :disabled="appLoading" small flat dark>Contact</v-btn>
      </v-flex>
      <v-flex class="pb-1 px-2 body-1" xs12 md8>
        <v-btn to="https://www.facebook.com/RophemReviews/" class="my-0 mr-3" color="blue darken-2" icon dark>
          <v-icon small>fab fa-facebook-f</v-icon>
        </v-btn>
        <v-btn to="https://twitter.com/ModupeRophem" class="my-0 mr-3" color="cyan lighten-2" icon dark>
          <v-icon small>fab fa-twitter</v-icon>
        </v-btn>
        <v-btn to="https://www.instagram.com/rophemnursing/" class="my-0" color="pink lighten-1" icon dark>
          <v-icon small>fab fa-instagram</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="pt-2 body-1" xs12 md8>Rophem LLC &copy; {{ new Date().getFullYear() }}</v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  computed: {
    appLoading () {
      return this.$store.getters.loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/Footer.vue